module.exports = __webpack_public_path__ + "img/ekyc-ibank-guide-03.193990c7.png";